(function () {
  const pad = n => n.toString().padStart(2, '0');

 /* ---------- helper: return next midnight in Europe/London ---------- */
function nextLondonMidnight () {
  const now = new Date();

  /* 1  Get “now” in London as a parse-friendly string               */
  const londonNow = new Date(
    now.toLocaleString('en-US', { timeZone: 'Europe/London' })
  );

  /* 2  Roll that to *tomorrow* 00:00 London time                     */
  londonNow.setHours(24, 0, 0, 0);   // 24:00 => next-day 00:00

  /* 3  Convert that moment back to an absolute timestamp             */
  const diff = londonNow.getTime() -
               new Date().toLocaleString('en-US', { timeZone: 'UTC' , hour12:false, hour:'2-digit', minute:'2-digit', second:'2-digit'}); // not needed?

  return londonNow;   // ← valid Date object
}

/* ---------- helper: next midnight in the visitor’s LOCAL zone ---------- */
function nextLocalMidnight () {
  const d = new Date();      // now, local
  d.setHours(24, 0, 0, 0);   // roll to 24:00 → same as tomorrow 00:00
  return d;                  // valid Date object
}

/* ---------- attach countdown to any .cdt element ---------- */
function startOne(el) {
  let target = nextLocalMidnight();        // let ⇒ we can update it later

  function tick () {
    let diff = target - Date.now();

    /* if we’ve hit (or passed) 00:00, jump to the next midnight */
    if (diff <= 0) {
      target = nextLocalMidnight();
      diff   = target - Date.now();        // recalc diff for the new target
    }

    const h = pad(Math.floor(diff / 36e5 % 24));
    const m = pad(Math.floor(diff / 6e4  % 60));
    const s = pad(Math.floor(diff / 1e3  % 60));

    el.querySelector('.js-cdt-h').textContent = h;
    el.querySelector('.js-cdt-m').textContent = m;
    el.querySelector('.js-cdt-s').textContent = s;
  }

  tick();                    // initial draw
  setInterval(tick, 1000);   // update every second
}

  document.addEventListener('DOMContentLoaded', () =>
    document.querySelectorAll('.cdt').forEach(startOne)
  );
})();